// MEDIAS
document.addEventListener('DOMContentLoaded', function () {
  var main = new Splide('#main-slider', {
    type: 'slide',
    rewind: false,
    pagination: true,
    arrows: true,
    breakpoints: {
      768: {
        gap: 10,
        pagination: false,
        padding: {
          left: '0px',
          right: '30px',
        },
      },
    },
  });

  main.mount();
  const splideReadyEvent = new CustomEvent('td:splideReady', { detail: main });
  window.dispatchEvent(splideReadyEvent);
});

//CHANGE QTTY
function mmChangeQtty(delta, inputId) {
  var input = document.getElementById(inputId);

  if (delta == '-1' && input.value == '1') {
  } else {
    input.value = parseInt(input.value, 10) + parseInt(delta, 10);
  }
}

let readMores = document.querySelectorAll('.read-more');
let readLesses = document.querySelectorAll('.read-less');

readMores.forEach((readMore) => {
  readMore.addEventListener('click', function () {
    let container = readMore.closest('.truncate-container');
    let truncatedDescription = container.querySelector('.truncated-product-description');
    let fullDescription = container.querySelector('.product-description');
    truncatedDescription.style.display = 'none';
    fullDescription.style.display = 'block';
  });
});

readLesses.forEach((readLess) => {
  readLess.addEventListener('click', function () {
    let container = readLess.closest('.truncate-container');
    let truncatedDescription = container.querySelector('.truncated-product-description');
    let fullDescription = container.querySelector('.product-description');
    truncatedDescription.style.display = 'block';
    fullDescription.style.display = 'none';
  });
});

//change current option when splide change index
var elements = document.querySelectorAll('.mm-product-form-variant-value');
var observer = new MutationObserver(function (events) {
  events.forEach(function (event) {
    if (event.target.classList.contains('is-active')) {
      event.target.querySelector('input').click();
      // get the queryparams variant and get the id to match in product card picker
      const variantIdUrlParams = new URLSearchParams(window.location.search).get('variant');
      document.dispatchEvent(new CustomEvent('deployer:variant-changed', { detail: { variant_id: variantIdUrlParams } }));
    }
  });
});

elements.forEach(function (element) {
  observer.observe(element, {
    attributes: true,
    attributeFilter: ['class'],
    childList: false,
    characterData: false,
  });
});

// ACCORDEONS
function mmAccordeon(clickedElem) {
  var elements = document.querySelectorAll('.mm-product-accordeon-container');

  elements.forEach(function (element) {
    element.classList.remove('mm-active');
  });

  clickedElem.classList.add('mm-active');
}

// ADD TO CART

function addToCart(hasEngraving = false) {
  if (hasEngraving) {
    const checkboxElement = document.querySelector('#engraving-checkbox');
    const engravingTextContainer = document.getElementById('engraving-text-property');
    const engravingText = engravingTextContainer ? engravingTextContainer.textContent.trim() : '';
    const engravingSelect = document.querySelector('engraved-compo #engraving-text-font');
    const engravingSelectValue = engravingSelect.dataset.font;
    const engravingOrientationInputs = document.querySelectorAll('engraved-compo [name=engraving-orientation]');

    let engravingOrientationValue;
    for (var i = 0; i < engravingOrientationInputs.length; i++) {
      if (engravingOrientationInputs[i].checked) {
        engravingOrientationValue = engravingOrientationInputs[i].value;
        break;
      }
    }

    if (checkboxElement.checked == true && engravingText !== '') {
      const properties = {
        text: engravingText,
        font: engravingSelectValue,
        orientation: engravingOrientationValue,
      };
      mmAddProductToCart(document.getElementById('mmVariantId').value, 1, true, properties);
    } else if (checkboxElement.checked == true && engravingText === '') {
      window.alert('Vous devez indiquer un texte pour valider votre gravure.');
    } else {
      mmAddProductToCart(document.getElementById('mmVariantId').value);
    }
  } else {
    mmAddProductToCart(document.getElementById('mmVariantId').value);
  }
}

/* Hide Sticky ATC if ATC visible*/

window.addEventListener('scroll', function () {
  var btn = document.querySelector('.mm-btn-primary[type="submit"]');
  var btnSticky = document.querySelector('.mm-sticky-cta');

  if (btn && btnSticky) {
    var rect = btn.getBoundingClientRect();
    if (rect.bottom <= 0) {
      btnSticky.style.display = 'flex';
    } else {
      btnSticky.style.display = 'none';
    }
  }
});